// Utilidades das listagens de arquivos importados (itens 4/5; fix B5).

// Clique originado em elemento interativo (ícone de ação, paginação,
// inputs) é tratado pelo próprio elemento — sem navegação duplicada
const INTERACTIVE_ELEMENTS_SELECTOR =
  'button, a, input, textarea, [role="button"]'

// B5 — clique gerado ao soltar um drag de seleção de texto (ex.: copiar o
// nome do arquivo) não deve navegar
const hasActiveTextSelection = () => {
  const selection = window.getSelection?.()
  return !!selection && !selection.isCollapsed
}

// Resolve o item da linha clicada na tabela do design system (o DataTable
// não emite evento de clique de linha): acha o <tr> via delegação e mapeia
// o índice da linha para o array de itens da página corrente
const resolveClickedRowItem = (event, items) => {
  if (hasActiveTextSelection()) return null
  if (event.target.closest(INTERACTIVE_ELEMENTS_SELECTOR)) return null

  const row = event.target.closest('tr[data-test-data-table-row]')
  if (!row || !row.parentElement) return null

  const index = Array.prototype.indexOf.call(row.parentElement.children, row)
  return (items || [])[index] || null
}

// Toda troca de filtro volta para a primeira página.
//
// `page` é só o indicador visual; quem recorta a consulta é `offset`. Zerar
// um sem o outro deixa a listagem mentindo: com `page: 1` e `offset: 40` a
// tabela mostra o terceiro recorte do resultado filtrado, e o botão
// "anterior" — escondido justamente quando `page === 1` — não existe para
// voltar. Os dois campos andam sempre juntos.
const resetPaginationToFirstPage = pagination => {
  if (!pagination) return

  pagination.page = 1
  pagination.offset = 0
}

export {
  resolveClickedRowItem,
  hasActiveTextSelection,
  resetPaginationToFirstPage,
}
